import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import { GlobalState } from './global.model';
import { fetchTrialAttributes } from './trial-level-requests/trial-attributes';
import { withTrialIdRequest } from './with-trial-id-request';

const initialState: GlobalState = {
  attributes: [],
  hierarchyAttributesLoaded: false,
  primaryAttribute: {
    attribute_name: '',
    expense_populated: false,
    values_populated: false,
  },
  secondaryAttribute: {
    attribute_name: '',
    expense_populated: false,
    values_populated: false,
  },
  selectedTrialId: '',
};

type KeysWithRefreshSuffix<T> = {
  [K in keyof T]: K extends `refresh${string}` ? K : never;
}[keyof T];

type StripRefreshFromKeys<K extends string> = K extends `refresh${infer S}` ? S : never;

export const GlobalStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withTrialIdRequest('TrialAttributes', fetchTrialAttributes),
  withMethods((store) => ({
    getLoading(key: StripRefreshFromKeys<KeysWithRefreshSuffix<typeof store>>) {
      return store[`${key}Loading`];
    },
    refreshRequest(key: StripRefreshFromKeys<KeysWithRefreshSuffix<typeof store>>) {
      store[`refresh${key}`]();
    },
    updateTrialId(trialId: string) {
      patchState(store, () => ({
        selectedTrialId: trialId,
      }));
    },
  }))
);

// inline type
//  key: {
//     [K in keyof typeof store]: K extends `refresh${string}` ? K : never;
//   }[keyof typeof store] extends `refresh${infer S}`
//     ? S
//     : never
